/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { WizardDataContext } from '../contexts/wizard-data-context';

export const useWizardData = <T,>() => {
    const context = useContext(WizardDataContext);
    return context.data as T;
};
